module.exports = __webpack_public_path__ + "static/media/my-courses.1f456898.svg";